import { createContext, useContext } from "react"

export type FullscreenToolbarSlots = {
  left: HTMLElement | null
  actions: HTMLElement | null
}

export const EMPTY_FULLSCREEN_TOOLBAR_SLOTS: FullscreenToolbarSlots = { left: null, actions: null }

// Both hosts live in AppShell toolbar chrome (Jobs/Panel stay in shell).
// Pages portal left children (search/title/badges) and optional create CTA into actions.
export const FullscreenToolbarSlotContext = createContext<FullscreenToolbarSlots>(EMPTY_FULLSCREEN_TOOLBAR_SLOTS)

export function useFullscreenToolbarSlot(): HTMLElement | null {
  return useContext(FullscreenToolbarSlotContext).left
}

export function useFullscreenToolbarActionsSlot(): HTMLElement | null {
  return useContext(FullscreenToolbarSlotContext).actions
}
